module.exports = __webpack_public_path__ + "static/media/hiking.881290e8.png";